export function isBrowser(): boolean {
  return typeof window !== "undefined";
}

export function isServer(): boolean {
  return !isBrowser();
}

export const isDev = isBrowser()
  ? window.location.href.indexOf("dev.travellocal.com") > -1 // TODO be better
  : process?.env?.NODE_ENV && process.env.NODE_ENV === "development";
